import React from 'react'
import Drawer from 'components/shared/Drawer'
import Button from 'components/shared/Button'
import { InputField } from 'components/forms/reduxForm'
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import CreditCost from 'components/shared/CreditCost'

const MotusSearchDrawer = ({
                               open,
                               onClose,
                               searchType,
                               setSearchType,
                               dotInput,
                               setDotInput,
                               nameInput,
                               setNameInput,
                               onSearch,
                               loading,
                               dotAlreadySearched,
                               creditCost,
                               creditUsageEnabled
                           }) => {
    return (
        <Drawer open={open} onClose={onClose} title='New Motus Search' width='small'>
            <div className='p-3'>
                <FormControl component="fieldset" className='mb-0'>
                    <FormLabel component="legend">Search Type</FormLabel>
                    <RadioGroup                        row                        value={searchType}                        onChange={(e) => setSearchType(e.target.value)}                        style={{ marginBottom: '-8px' }}                    >
                        <FormControlLabel value="dot" control={<Radio color="primary" />} label="DOT Search" />
                        <FormControlLabel value="name" control={<Radio color="primary" />} label="Name Search" />
                    </RadioGroup>
                </FormControl>

                {searchType === 'dot' ? (
                    <div className='mb-3'>
                        <InputField                            name='motusDot'                            label='DOT Number'                            required                            id='motusDotInput'                            input={{ value: dotInput, onChange: (e) => setDotInput(e.target.value) }}                        />
                        {dotAlreadySearched && (
                            <Alert severity="warning" style={{ marginTop: '8px' }}>
                                This DOT number has already been searched.
                            </Alert>
                        )}
                    </div>
                ) : (
                    <div className='mb-3'>
                        <InputField                            name='motusName'                            label='Business Name'                            required                            id='motusNameInput'                            input={{ value: nameInput, onChange: (e) => setNameInput(e.target.value) }}                        />
                    </div>
                )}

                <Button                    variant='contained'                    color='primary'                    onClick={onSearch}                    loading={loading}                    disabled={searchType === 'dot' ? !dotInput : !nameInput}                    endIcon={creditUsageEnabled && creditCost ? <CreditCost cost={creditCost} /> : undefined}                >
                    Search
                </Button>
            </div>
        </Drawer>
    )
}

export default MotusSearchDrawer